var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { "body-class": "p-3" } },
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "text-center text-danger my-2" },
            [
              _c("b-spinner", { staticClass: "align-middle" }),
              _vm._v(" "),
              _c("strong", [_vm._v("Lade Details...")]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "b-row",
            [
              _c("b-col", { staticClass: "d-lg-none", attrs: { cols: "10" } }, [
                _c("dl", { staticClass: "row mb-3" }, [
                  _c("dt", { staticClass: "col-5" }, [_vm._v("Verderblich:")]),
                  _vm._v(" "),
                  _c("dd", { staticClass: "col-7 mb-0" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatIngredientPerishable(
                          _vm.item.ingredient_perishable
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", { staticClass: "col-5" }, [_vm._v("Zoll:")]),
                  _vm._v(" "),
                  _c("dd", { staticClass: "col-7 mb-0" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatCustomsCategory(_vm.item.customs_category)
                      )
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "d-lg-none", attrs: { cols: "2" } }, [
                _c("i", {
                  staticClass: "float-right fas fa-times",
                  on: { click: _vm.hideDetails },
                }),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm.item.ingredient_title) + " wird benötigt für:"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-table-simple",
                    { attrs: { borderless: "" } },
                    [
                      _c(
                        "b-tbody",
                        _vm._l(
                          _vm.item.details.sources,
                          function (source, index) {
                            return _c(
                              "b-tr",
                              { key: index },
                              [
                                _c("b-td", [
                                  source.source_type === "recipe"
                                    ? _c("span", [_vm._v("Rezept:")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  source.source_type === "material-list"
                                    ? _c("span", [_vm._v("Materialliste:")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  source.source_date
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatDate(
                                              source.source_date.date,
                                              "D.M.Y"
                                            )
                                          ) + " -"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(source.source_title)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("b-td", { staticClass: "text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatAmountNeeded(
                                        source.amount_needed,
                                        "amount_needed",
                                        _vm.item
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.item.base_unit_title)
                                  ),
                                ]),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "5", "offset-md": "1" } },
                [
                  _vm.canEdit
                    ? _c(
                        "b-btn",
                        {
                          staticClass: "float-right",
                          attrs: { size: "xs", disabled: _vm.isSaving },
                          on: { click: _vm.resetDelta },
                        },
                        [_vm._v("Zurücksetzen")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h5", [_vm._v("Berechnung:")]),
                  _vm._v(" "),
                  _c(
                    "b-table-simple",
                    { staticClass: "mb-0", attrs: { borderless: "" } },
                    [
                      _c(
                        "b-tbody",
                        [
                          _c(
                            "b-tr",
                            [
                              _c("b-td", [_vm._v("Berechnete Menge:")]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatAmountNeeded(
                                      _vm.item.amount_needed,
                                      "amount_needed",
                                      _vm.item
                                    )
                                  ) +
                                    " " +
                                    _vm._s(_vm.item.base_unit_title)
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tr",
                            [
                              _c("b-td", [_vm._v("Vorhandene Reste:")]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "- " +
                                    _vm._s(
                                      _vm.formatAmountNeeded(
                                        _vm.item.details.amount_available || 0,
                                        "amount_available",
                                        _vm.item
                                      )
                                    ) +
                                    " " +
                                    _vm._s(_vm.item.base_unit_title)
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tr",
                            [
                              _c("b-td", [_vm._v("Eigene Anpassung:")]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.localDelta < 0 ? "-" : "+") +
                                    "\n              " +
                                    _vm._s(
                                      _vm.formatAmountNeeded(
                                        Math.abs(_vm.localDelta),
                                        null,
                                        _vm.item
                                      )
                                    ) +
                                    " " +
                                    _vm._s(_vm.item.base_unit_title) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "calculation-sum" }, [
                    _c("div", { staticClass: "float-left" }, [
                      _vm._v("Summe:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "float-right" },
                      [
                        _vm.canEdit
                          ? _c(
                              "b-input-group",
                              { attrs: { size: "sm" } },
                              [
                                _c("b-form-input", {
                                  staticClass: "text-right",
                                  attrs: {
                                    type: "number",
                                    step: Math.pow(
                                      10,
                                      -_vm.item.base_unit_precision
                                    ),
                                    readonly: _vm.isSaving,
                                  },
                                  nativeOn: {
                                    keydown: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.submitDelta.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.localShopping,
                                    callback: function ($$v) {
                                      _vm.localShopping = $$v
                                    },
                                    expression: "localShopping",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c("b-input-group-text", [
                                      _vm._v(_vm._s(_vm.item.base_unit_title)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-btn",
                                      {
                                        staticClass: "save-row-details",
                                        attrs: {
                                          variant: "primary",
                                          disabled: _vm.isSaving,
                                        },
                                        on: { click: _vm.submitDelta },
                                      },
                                      [
                                        !_vm.isSaving
                                          ? _c("i", {
                                              staticClass: "fas fa-save",
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isSaving
                                          ? _c("b-spinner", {
                                              attrs: {
                                                small: "",
                                                variant: "light",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.canEdit
                          ? _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.formatAmountNeeded(
                                      _vm.item.amount_shopping,
                                      null,
                                      _vm.item
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.item.base_unit_title) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }